export default __webpack_public_path__ + "static/media/turnKey-3.8240c3ca.jpg";